import { useState } from "react";
import { Link } from "react-router-dom";
import {
  LayoutDashboard, TrendingUp, Package, Wallet, Shield, Settings2,
  ShoppingBag, MessageCircle, MessageSquare, BarChart3, Sparkles,
  FileText, CreditCard, Heart, Warehouse, Truck, Inbox, Banknote,
  Search, Bell, ChevronDown, ArrowLeft, CircleDot,
} from "lucide-react";

// ─── Shared mock data ────────────────────────────────────────────────────
export const MOCK = {
  seller: {
    portalName: "Seller portal",
    userName: "Verdant Naturals",
    userInitials: "VN",
    userEmail: "demo.seller@verqo.com",
    partnerLabel: "Buyer",
    partnersLabel: "Buyers",
    kpis: [
      { label: "Active buyers",    value: "4",       hint: "3 healthy" },
      { label: "Orders · 30d",     value: "283",     hint: "+18% vs prev" },
      { label: "GMV · 30d",        value: "$33,780" },
      { label: "MAP violations",   value: "1",       hint: "Urban Tots · today", accent: "warn" },
    ],
    partners: [
      { id: "p1", name: "Daisy & Co Boutique", channel: "Shopify",        orders30d: 142, gmv30d: 18450, health: "ok",    sync: "2m ago",  mapOk: true,  agreement: "Active", credit: "$4.2K / $15K" },
      { id: "p2", name: "Northside Pharmacy",  channel: "WooCommerce",    orders30d:  88, gmv30d:  9210, health: "ok",    sync: "12m ago", mapOk: true,  agreement: "Active", credit: "$2.1K / $10K" },
      { id: "p3", name: "Urban Tots",          channel: "Custom Webhook", orders30d:  41, gmv30d:  4780, health: "warn",  sync: "3h ago",  mapOk: false, agreement: "Active", credit: "$800 / $5K" },
      { id: "p4", name: "Coastal Mercantile",  channel: "Shopify",        orders30d:  12, gmv30d:  1340, health: "error", sync: "Failed",  mapOk: true,  agreement: "Active", credit: "$0 / $3K" },
    ],
    catalog: [
      { sku: "VRD-501", name: "Organic Bamboo Tee · M",  msrp: 38, map: 30, wholesale: 14.50, handling: 1.20, mirrored: 3 },
      { sku: "VRD-502", name: "Organic Bamboo Tee · L",  msrp: 38, map: 30, wholesale: 14.50, handling: 1.20, mirrored: 3 },
      { sku: "RDG-114", name: "Cabin Crew Socks · 3pk",  msrp: 24, map: 19, wholesale:  8.00, handling: 0.90, mirrored: 2 },
      { sku: "SBT-301", name: "Maple Crunch Trail Mix",  msrp: 12, map: 10, wholesale:  4.20, handling: 0.50, mirrored: 4 },
      { sku: "VRD-503", name: "Linen Napkin Set · 4pk",  msrp: 42, map: 34, wholesale: 15.80, handling: 1.40, mirrored: 1 },
      { sku: "RDG-201", name: "Waffle Robe · Adult",     msrp: 88, map: 72, wholesale: 34.00, handling: 2.00, mirrored: 2 },
    ],
    orders: [
      { id: "DS-21041", partner: "Daisy & Co Boutique", customer: "Anna L.",   total: 142.00, status: "Action needed", note: "Add tracking by 5pm",       sla: "2h" },
      { id: "DS-21040", partner: "Daisy & Co Boutique", customer: "Marc T.",   total:  38.00, status: "In transit",    note: "UPS · 2 days out" },
      { id: "DS-21039", partner: "Northside Pharmacy",  customer: "Lila R.",   total: 211.00, status: "Delivered",     note: "Invoice $211 · debited" },
      { id: "DS-21038", partner: "Urban Tots",          customer: "Owen S.",   total:  76.00, status: "Stalled",       note: "No movement 48h" },
      { id: "DS-21037", partner: "Coastal Mercantile",  customer: "Jia W.",    total: 189.00, status: "Claim",         note: "Damaged · refund pending" },
    ],
  },
  buyer: {
    portalName: "Buyer portal",
    userName: "Daisy & Co Boutique",
    userInitials: "DC",
    userEmail: "demo.buyer@verqo.com",
    partnerLabel: "Supplier",
    partnersLabel: "Suppliers",
    kpis: [
      { label: "Active suppliers", value: "3",       hint: "2 healthy" },
      { label: "Orders · 30d",     value: "162",     hint: "+22% vs prev" },
      { label: "Purchases · 30d",  value: "$22,230" },
      { label: "Margin · avg",     value: "60%",     hint: "vs 58% last month" },
    ],
    partners: [
      { id: "s1", name: "Verdant Naturals",      channel: "—", orders30d: 84, gmv30d: 12300, health: "ok",   sync: "Real-time", mapOk: true,  agreement: "Active", credit: "$4.2K / $15K" },
      { id: "s2", name: "Ridgeline Apparel Co.", channel: "—", orders30d: 56, gmv30d:  7820, health: "ok",   sync: "Real-time", mapOk: true,  agreement: "Active", credit: "$1.1K / $8K" },
      { id: "s3", name: "Sunbelt Snack Group",   channel: "—", orders30d: 22, gmv30d:  2110, health: "warn", sync: "Real-time", mapOk: false, agreement: "Pending", credit: "$310 / $3K" },
    ],
    catalog: [
      { sku: "VRD-501", name: "Organic Bamboo Tee · M",  supplier: "Verdant Naturals",  wholesale: 14.50, msrp: 38, margin: 0.58, inStore: true  },
      { sku: "RDG-114", name: "Cabin Crew Socks · 3pk",  supplier: "Ridgeline Apparel", wholesale:  8.00, msrp: 24, margin: 0.62, inStore: true  },
      { sku: "SBT-301", name: "Maple Crunch Trail Mix",  supplier: "Sunbelt Snack",     wholesale:  4.20, msrp: 12, margin: 0.61, inStore: false },
      { sku: "VRD-503", name: "Linen Napkin Set · 4pk",  supplier: "Verdant Naturals",  wholesale: 15.80, msrp: 42, margin: 0.60, inStore: false },
      { sku: "RDG-201", name: "Waffle Robe · Adult",     supplier: "Ridgeline Apparel", wholesale: 34.00, msrp: 88, margin: 0.60, inStore: true  },
    ],
    orders: [
      { id: "DS-21041", partner: "Verdant Naturals",  customer: "Anna L.",   total: 142.00, status: "Action needed", note: "Waiting on tracking",       sla: "2h" },
      { id: "DS-21040", partner: "Verdant Naturals",  customer: "Marc T.",   total:  38.00, status: "In transit",    note: "UPS · 2 days out" },
      { id: "DS-21039", partner: "Ridgeline Apparel", customer: "Lila R.",   total: 211.00, status: "Delivered",     note: "Invoice $211 · debited" },
      { id: "DS-21038", partner: "Sunbelt Snack",     customer: "Owen S.",   total:  76.00, status: "Stalled",       note: "No movement 48h" },
      { id: "DS-21037", partner: "Verdant Naturals",  customer: "Jia W.",    total: 189.00, status: "Claim",         note: "Damaged · refund pending" },
    ],
  },
};

// ─── Portal chrome (sidebar + topbar) ────────────────────────────────────
const SIDEBAR_SELLER_CORE = [
  { label: "Dashboard", icon: LayoutDashboard },
  { label: "Buyers",    icon: TrendingUp },
  { label: "Orders",    icon: Package },
  { label: "Payouts",   icon: Wallet },
  { label: "Insurance", icon: Shield },
  { label: "Settings",  icon: Settings2 },
];
const SIDEBAR_SELLER_APPS = [
  { label: "Catalog",  icon: Package },
  { label: "Messages", icon: MessageCircle },
  { label: "Dropship", icon: ShoppingBag, active: true },
  { label: "RFQ",      icon: MessageSquare },
  { label: "Reports",  icon: BarChart3 },
];
const SIDEBAR_BUYER_CORE = [
  { label: "Dashboard",         icon: LayoutDashboard },
  { label: "Orders",            icon: FileText },
  { label: "Payments",          icon: CreditCard },
  { label: "Shipping",          icon: Truck },
  { label: "Score",             icon: TrendingUp },
  { label: "PO Inbox",          icon: Inbox },
  { label: "Invoice financing", icon: Banknote },
];
const SIDEBAR_BUYER_APPS = [
  { label: "Catalog",   icon: ShoppingBag },
  { label: "Messages",  icon: MessageCircle },
  { label: "Suppliers", icon: Heart },
  { label: "Dropship",  icon: Package, active: true },
  { label: "RFQ",       icon: MessageSquare },
  { label: "Inventory", icon: Warehouse },
  { label: "Reports",   icon: BarChart3 },
];

export function PortalChrome({ role, setRole, optionLabel, optionNumber, children }) {
  const core = role === "seller" ? SIDEBAR_SELLER_CORE : SIDEBAR_BUYER_CORE;
  const apps = role === "seller" ? SIDEBAR_SELLER_APPS : SIDEBAR_BUYER_APPS;
  const meta = MOCK[role];

  return (
    <div className="min-h-screen bg-zinc-50 flex flex-col">
      {/* Preview banner */}
      <div className="bg-zinc-900 text-white text-[11px] px-6 py-1.5 flex items-center gap-3 flex-shrink-0">
        <Link to="/preview/dropship-options" className="inline-flex items-center gap-1 text-zinc-300 hover:text-white">
          <ArrowLeft className="w-3 h-3" /> All options
        </Link>
        <span className="text-zinc-500">·</span>
        <span><Sparkles className="w-3 h-3 text-amber-300 inline mr-1" /> {optionLabel}</span>
        <span className="ml-auto inline-flex rounded-full bg-white/10 p-0.5">
          <button onClick={() => setRole("seller")} className={`text-[11px] px-3 py-0.5 rounded-full ${role === "seller" ? "bg-white text-zinc-900 font-semibold" : "text-zinc-300"}`}>Seller</button>
          <button onClick={() => setRole("buyer")}  className={`text-[11px] px-3 py-0.5 rounded-full ${role === "buyer"  ? "bg-white text-zinc-900 font-semibold" : "text-zinc-300"}`}>Buyer</button>
        </span>
        <span className="text-zinc-500 font-mono">Option {optionNumber}/4</span>
      </div>

      <div className="flex flex-1 min-h-0">
        <aside className="w-60 bg-white border-r border-zinc-200 flex-shrink-0 flex flex-col">
          <div className="px-4 h-14 flex items-center gap-2 border-b border-zinc-100">
            <div className="w-7 h-7 rounded-md bg-zinc-900 text-white flex items-center justify-center text-xs font-bold">v</div>
            <div>
              <div className="text-[11px] font-semibold leading-tight">verqo</div>
              <div className="text-[10px] text-zinc-500 leading-tight">{role === "seller" ? "Seller" : "Buyer"}</div>
            </div>
            <ChevronDown className="w-3.5 h-3.5 ml-auto text-zinc-400" />
          </div>
          <nav className="flex-1 p-3 overflow-y-auto">
            <div className="text-[10px] uppercase tracking-widest text-zinc-400 px-3 mb-2">Core</div>
            <div className="space-y-0.5 mb-4">
              {core.map(item => {
                const Icon = item.icon;
                return (
                  <div key={item.label} className="flex items-center gap-2.5 rounded-lg px-3 py-1.5 text-[13px] text-zinc-600 hover:bg-zinc-50">
                    <Icon className="w-4 h-4" /> {item.label}
                  </div>
                );
              })}
            </div>
            <div className="text-[10px] uppercase tracking-widest text-zinc-400 px-3 mb-2">Apps</div>
            <div className="space-y-0.5">
              {apps.map(item => {
                const Icon = item.icon;
                return (
                  <div key={item.label} className={`flex items-center gap-2.5 rounded-lg px-3 py-1.5 text-[13px] ${item.active ? "bg-zinc-900 text-white font-medium" : "text-zinc-600 hover:bg-zinc-50"}`}>
                    <Icon className="w-4 h-4" /> {item.label}
                  </div>
                );
              })}
            </div>
          </nav>
          <div className="border-t border-zinc-100 p-3 flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-zinc-200 flex items-center justify-center text-[11px] font-semibold">{meta.userInitials}</div>
            <div className="flex-1 min-w-0">
              <div className="text-[12px] font-medium truncate">{meta.userName}</div>
              <div className="text-[10px] text-zinc-500 truncate">{meta.userEmail}</div>
            </div>
          </div>
        </aside>

        <div className="flex-1 flex flex-col min-w-0">
          <header className="h-14 bg-white border-b border-zinc-200 px-6 flex items-center gap-4 flex-shrink-0">
            <div className="text-xs text-zinc-500">{meta.portalName}</div>
            <div className="text-zinc-300">·</div>
            <div className="text-xs"><span className="text-zinc-500">Apps</span><span className="text-zinc-400 mx-1">/</span><span className="text-zinc-900 font-medium">Dropship</span></div>
            <div className="ml-auto flex items-center gap-3">
              <div className="hidden md:flex items-center gap-2 bg-zinc-50 ring-1 ring-zinc-200 rounded-md px-2.5 py-1.5">
                <Search className="w-3.5 h-3.5 text-zinc-400" />
                <span className="text-xs text-zinc-400">Search…</span>
                <kbd className="text-[10px] bg-white px-1 rounded text-zinc-400 ring-1 ring-zinc-200">⌘K</kbd>
              </div>
              <Bell className="w-4 h-4 text-zinc-500" />
              <div className="w-7 h-7 rounded-full bg-zinc-200 flex items-center justify-center text-[11px] font-semibold">{meta.userInitials}</div>
            </div>
          </header>
          {children}
        </div>
      </div>
    </div>
  );
}

// ─── Shared small UI atoms ───────────────────────────────────────────────
export const HealthPill = ({ kind, children }) => {
  const map = {
    ok:    "bg-emerald-50 text-emerald-700 ring-emerald-200",
    warn:  "bg-amber-50 text-amber-700 ring-amber-200",
    error: "bg-red-50 text-red-700 ring-red-200",
  };
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full ring-1 ${map[kind] || map.ok}`}>
      <CircleDot className="w-2.5 h-2.5" /> {children}
    </span>
  );
};

export const StatusPill = ({ status }) => {
  const map = {
    "Action needed": "bg-amber-50 text-amber-700 ring-amber-200",
    "In transit":    "bg-blue-50 text-blue-700 ring-blue-200",
    "Delivered":     "bg-emerald-50 text-emerald-700 ring-emerald-200",
    "Stalled":       "bg-orange-50 text-orange-700 ring-orange-200",
    "Claim":         "bg-red-50 text-red-700 ring-red-200",
  };
  return <span className={`text-[11px] font-medium px-2 py-0.5 rounded-full ring-1 ${map[status] || "bg-zinc-50 text-zinc-700 ring-zinc-200"}`}>{status}</span>;
};

export function useRole() {
  return useState("seller");
}
